import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal } from 'components/ui';

import * as Styled from './DeleteConfirmationModal.styles';

export const DeleteConfirmationModal = ({ onClose, onConfirm, isSaving }) => {
  return (
    <Modal title="Usunąć adres e-mail?" onClose={onClose}>
      <Styled.Message>Czy na pewno chcesz usunąć adres e-mail? Tej operacji nie będzie można cofnąć.</Styled.Message>

      <Styled.Actions>
        <Button onClick={onClose} variant="outlined">
          Anuluj
        </Button>
        <Button onClick={onConfirm} loading={isSaving} color="error">
          Tak, usuń
        </Button>
      </Styled.Actions>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
